export default "__VITE_ASSET__cTPYm_u$__"